<template>
  <span class="text-left">
    <h6 class="text-center"><a @click.stop="showModal = true" class="ogl">Open Game License</a></h6>
    <ez-modal v-if="showModal" @close="showModal = false" size="m-large">
      <div v-html="$embers.markdownIt(ogl.body)"></div>
    </ez-modal>
  </span>
</template>

<script>
import { mapState, mapActions } from "vuex";

import EzModalDelete from "@/components/shared/_VueEzModalDelete";
import modal from "@/mixins/vue-ez-modal";

export default {
  name: "vue-ez-modal-options",
  components: {
    EzModalDelete
  },
  mixins: [modal],
  props: ["item"],
  created() {
    this.getData();
  },
  computed: {
    ...mapState({
      ogl: state => state.pages.ogl
    })
  },
  methods: {
    ...mapActions({
      pagesOgl: "pages/ogl"
    }),
    async getData() {
      try {
        await this.pagesOgl();
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.ogl {
  font-size: 0.875em;
}
</style>
